import { Component, Host, h, Prop } from '@stencil/core';
import { HTMLAnchorElementTarget } from '../../utils/helpers';

@Component({
  tag: 'vds-read-more',
  styleUrl: 'vds-read-more.scss',
  shadow: true,
})
export class VdsReadMore {

  /**
   * Label of the button
   */
   @Prop() label: string;

   /**
   * Href of anchor
   */
  @Prop() href: string;
  /**
   * Target of anchor
   */
  @Prop() target: HTMLAnchorElementTarget = '_self';

  render() {
    const { href, label, target } = this;

    return (
      <Host>
        <a
        href={href}
        target={target}
        rel={target === '_blank' ? 'noopener' : undefined}
        class="relative text-berry hover:no-underline sm:text-sidebar-desktop text-sidebar-mobile"
        >
          <span class="hover-underline-text">{label}</span>
          <svg viewBox="0 0 18 24">
            <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5"></polyline>
          </svg>
          <div class="hover-underline-overlay"></div>
        </a>
      </Host>
    );
  }

}
